import { render, staticRenderFns } from "./ProductSpecificationsList.vue?vue&type=template&id=12c5da4a&scoped=true&"
import script from "./ProductSpecificationsList.vue?vue&type=script&lang=js&"
export * from "./ProductSpecificationsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecificationsList.vue?vue&type=style&index=0&id=12c5da4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5da4a",
  null
  
)

export default component.exports